import Footer from '../../components/global/Footer';
import { BASE_URL } from '../../services/constants';

export default function NotFound() {
  return (
    <>
      <div className="min-h-[calc(100vh-200px)] flex flex-col items-center justify-center bg-gray-100 p-6">
        <h1 className="text-6xl md:text-7xl font-juana font-bold text-black text-center mb-2">404 No encontrada</h1>
        <a
          href={`${BASE_URL}/`}
          className="text-5xl md:text-6xl font-juana font-bold text-blue-600 text-center mb-8 hover:underline"
        >
          Regreso
        </a>
      </div>
      <Footer />
    </>
  );
}


